export const commonEnvironment = {
  /**商户代号，随分支固定不变。用于监控与第三方服务的商户归因 */
  merchant: 'm9',
  /**指纹收费版接口域名 */
  fpEndpoint: 'https://finger-api.kzxdwqpl.com',
  /**指纹收费版js域名 */
  fpEndpointJS: 'https://fiuspzry.athena25.com',
  /**指纹收费版apikey */
  fpApiKey: 'KslqJpPa2AxCPSdbu2ws',
};

/** 部署階段(單一真相,取代散落各處的 isOnline / isUat / isSit 組合判斷) */
export type DeployEnv = 'prod' | 'uat' | 'sit' | 'dev';

/**
 * 由既有旗標推導部署階段,不需要新增 pipeline 變數。
 *
 * 判斷順序必須「最具體優先」:
 * `isOnline` 實際語意是「使用正式等級的資源與行為」,不是「處於 prod 階段」。
 * 本分支目前沒有 isOnline 與 isUat 同時為 true 的 pipeline,但其他商戶有
 * (例如 M1 的 eur-uat-1),排序仍與各商戶保持一致,避免日後開 eur 站踩到。
 *
 * `dev` 只能由 production 判斷,不能用「三個旗標皆 false」反推 ——
 * environment.prod.ts 的 token 若沒被 pipeline 替換,旗標同樣會全部是 false。
 *
 * | pipeline    | isSit | isUat | isOnline | => env |
 * | ----------- | ----- | ----- | -------- | ------ |
 * | prod-9      |       |       | v        | prod   |
 * | uat-9       |       | v     |          | uat    |
 * | sit-9       | v     |       |          | sit    |
 * | 本地 ng serve |       |       |          | dev    |
 */
export const resolveDeployEnv = (e: {
  production: boolean;
  version: string;
  isSit: boolean;
  isUat: boolean;
  isOnline: boolean;
}): DeployEnv => {
  // 本地 ng serve(走 environment.ts)
  if (!e.production) return 'dev';
  // token 未被 pipeline 替換(例如本地直接跑 build-prod),旗標全部不可信
  if (/^#\{.*\}#$/.test(e.version)) return 'dev';
  if (e.isSit) return 'sit';
  if (e.isUat) return 'uat';
  if (e.isOnline) return 'prod';
  // 沒有任何旗標成立:走安全方向(顯示 debug、使用測試憑證)
  return 'dev';
};
